import { AnnotationBase } from '../../common/annotation/annotation';
import { appendElement, redrawElement } from '../../common/utils/helper';
import { createElement } from '@syncfusion/ej2-base';
/**
 * `ChartAnnotation` module handles the annotation for chart.
 */
export class ChartAnnotation extends AnnotationBase {
    /**
     * Constructor for chart annotation.
     *
     * @private
     */
    constructor(control, annotations) {
        super(control);
        this.chart = control;
        this.annotations = annotations;
    }
    /**
     * Method to render the annotation for chart
     *
     * @param {Element} element annotation element
     * @private
     */
    renderAnnotations(element) {
        this.annotations = this.chart.annotations;
        this.parentElement = redrawElement(this.chart.redraw, this.chart.element.id + '_Annotation_Collections') ||
            createElement('div', {
                id: this.chart.element.id + '_Annotation_Collections'
            });
        this.annotations.map((annotation, index) => {
            this.processAnnotation(annotation, index, this.parentElement);
        });
        appendElement(this.parentElement, element, this.chart.redraw);
    }
    /**
     * To destroy the annotation.
     *
     * @returns {void}
     * @private
     */
    destroy() {
        // Destroy method performed here
    }
    /**
     * Get module name.
     */
    getModuleName() {
        // Returns te module name
        return 'Annotation';
    }
}
